import { Action } from '@occc-app/rootRedux';

import types, { AGE_WITHIN, IN_ALL_SEGMENTS, IN_ANY_SEGMENTS, State } from './types';

import { default as offerTypes } from '../../../redux/types';

export const initialState: State = {
  ageWithin: {
    active: false,
    dirty: false,
    error: null,
    errorMessages: [],
    id: '',
    maximumAge: 99,
    maximumAgeActive: false,
    minimumAge: 18,
    minimumAgeActive: false,
    submitting: false,
    type: AGE_WITHIN,
  },
  inAllSegments: {
    active: false,
    availableSegments: [],
    dirty: false,
    error: null,
    errorMessages: [],
    id: '',
    segments: [],
    submitting: false,
    type: IN_ALL_SEGMENTS,
  },
  inAnySegments: {
    active: false,
    availableSegments: [],
    dirty: false,
    error: null,
    errorMessages: [],
    id: '',
    segments: [],
    submitting: false,
    type: IN_ANY_SEGMENTS,
  },
  error: null,
  errorMessages: [],
  requesting: true,
};

export function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case types.AUDIENCE_COMPONENT_ERR:
      const { audienceType: audienceTypeERR, error, errorMessages } = action;
      return {
        ...state,
        [audienceTypeERR]: {
          ...state[audienceTypeERR],
          error,
          errorMessages,
        },
      };
    case types.AUDIENCE_COMPONENT_OK:
      const { audienceType: audienceTypeOK, id } = action;
      return {
        ...state,
        [audienceTypeOK]: {
          ...state[audienceTypeOK],
          id,
          error: null,
          errorMessages: [],
          dirty: false,
        },
      };
    case types.AUDIENCE_COMPONENTS_ERR:
      const { error: audienceComponentsError, errorMessages: audienceComponentsErrorMessages } =
        action;
      return {
        ...state,
        error: audienceComponentsError,
        errorMessages: audienceComponentsErrorMessages,
      };
    case types.AUDIENCE_COMPONENTS_OK:
      return {
        ...state,
        error: null,
        errorMessages: [],
      };
    case types.AUDIENCE_CONFIGURATION_UPDATE:
      const { audienceConfigurationKey } = action;
      return {
        ...state,
        [audienceConfigurationKey]: {
          ...state[audienceConfigurationKey],
          [action.key]: action.value,
          dirty: true,
        },
      };
    case types.AUDIENCE_TOGGLE_UPDATE:
      const { audienceConfigurationKey: toggledConfiguration } = action;
      return {
        ...state,
        [toggledConfiguration]: {
          ...state[toggledConfiguration],
          dirty: true,
          active: !state[toggledConfiguration].active,
        },
      };
    case types.REQUEST_AUDIENCE:
      return {
        ...state,
        [action.audienceType]: {
          ...state[action.audienceType],
          id: action.id,
          error: null,
          errorMessages: [],
          dirty: true,
        },
      };
    case types.REQUEST_AUDIENCE_OK:
      const selectedAudienceType = action.selectedAudience.type;
      return {
        ...state,
        [selectedAudienceType]: {
          ...state[selectedAudienceType],
          error: null,
          errorMessages: [],
          dirty: false,
          ...action.selectedAudience,
        },
      };
    case types.REQUEST_AUDIENCES_OK:
      return {
        ...state,
        requesting: false,
      };
    case types.REQUEST_SEGMENTS_OK:
      return {
        ...state,
        inAllSegments: {
          ...state.inAllSegments,
          availableSegments: action.segments,
        },
        inAnySegments: {
          ...state.inAnySegments,
          availableSegments: action.segments,
        },
      };
    case types.RESET_INITIAL_AUDIENCES_STATE:
      return {
        ...state,
        ...action.audiences,
      };
    case offerTypes.CLEAR_OFFER_COMPONENT_STATE:
      return initialState;
  }
  return state;
}
